'use strict';
const goldFileKey = function (pathInfo, license) {
		if (pathInfo.version === 1) {
			return pathInfo.fileId + '.mup';
		}
		if (pathInfo.new && pathInfo.title) {
			return pathInfo.title + '.new';
		}
		if (pathInfo.free && pathInfo.title && license) {
			return pathInfo.title + '.new';
		}
		return pathInfo.fileId + '.pointer';
	},
	loadFile = function (config, pageState, s3FileModel, collaborationModel, resourceManager, navigatorShim, goldFileChangesModel) {
		if (!config || !navigatorShim || !collaborationModel || !pageState || !s3FileModel || !resourceManager || !goldFileChangesModel) {
			return Promise.reject('invalidRequest');
		}

		if (pageState.isInitialised) {
			return Promise.reject('reauthenticated');
		}

		const pathInfo = pageState.getPathInfo();

		if (!pathInfo) {
			return Promise.reject('invalidRequest');
		}

		return new Promise((resolve, reject) => {
			let fileLoadTimeoutId = false,
				localSessionId,
				isTimedout = false;
			const doClearTimeout = function () {
					if (fileLoadTimeoutId) {
						navigatorShim.clearTimeout(fileLoadTimeoutId);
						fileLoadTimeoutId = 0;
					}
				},
				startTimeout = function () {
					const timeout = config.timeout || 120000;
					doClearTimeout();
					fileLoadTimeoutId = navigatorShim.setTimeout(() => {
						isTimedout = true;
						reject('network-error');

					}, timeout);
				};
			startTimeout();
			s3FileModel.getLoadConfig(pathInfo)
			.then((loadConfig) => {
				localSessionId = loadConfig.sessionId || '';
				return pageState.setLoadConfig(loadConfig);
			})
			.then((loadConfig) => {
				goldFileChangesModel.setHistoryPath(loadConfig.historyUrl, loadConfig.hasHistory);
				return s3FileModel.loadFile(pathInfo, loadConfig);
			})
			.then((content) => {
				const loadHistoryFrom = content && content.attr && content.attr['watermark-bytes'];
				if (!pathInfo.gold && !pathInfo.goldFileShare) {
					return {content: content, events: []};
				}
				return goldFileChangesModel.loadEvents(loadHistoryFrom)
				.then((events) => {
					return {
						content: content,
						events: events
					};
				});
			})
			.then((contentAndChanges) => {
				if (isTimedout) {
					return;
				}
				collaborationModel.initializeSession(localSessionId, contentAndChanges.content, contentAndChanges.events);
				return resourceManager.resignUrls(contentAndChanges.events);
			})
			.then(() => {
				if (isTimedout) {
					return;
				}
				if (pathInfo.new && !pathInfo.fileId) {
					pathInfo.fileId = Date.now();
					navigatorShim.replaceUrl(config.defaultFileTitle,  config.editorUrl + '/new/' + pathInfo.fileId);
				} else if (pathInfo.gold && !pathInfo.crowdlink) {
					navigatorShim.replaceUrl(pageState.getPageTitle(),  config.editorUrl + '/_v2/' + pageState.getFileId());
				}
				pageState.isInitialised = true;
			})
			.then(() => {
				doClearTimeout();
				resolve(pageState.getPathInfo());
			})
			.catch((reason) => {
				//console.log('error', reason); //eslint-disable-line
				doClearTimeout();
				reject(reason);
			});

		});
	},
	fileIdFromSaveConfig = function (saveConfig) {
		if (!saveConfig || !saveConfig.key || !saveConfig.key.length) {
			return false;
		}
		const components = saveConfig.key.split('/');

		if (!components || !components.length || components.length < 2) {
			return false;
		}
		if (saveConfig.free) {
			return components.slice(1).join('/');
		}
		return components[1];
	},
	calculateFileUrl = function (editorUrl, fileId, isFree) {
		if (!editorUrl || !fileId) {
			return false;
		}
		const typeComponent = isFree ? '_free' : '_v2';
		return [editorUrl, typeComponent, fileId].join('/')
		;
	},
	saveFile = function (pathInfo, contentToSave, s3FileModel) {
		return s3FileModel.goldFileSaveConfiguration(pathInfo)
		.then(saveConfiguration => s3FileModel.saveGoldFile(saveConfiguration, contentToSave));
	};

module.exports = {
	calculateFileUrl: calculateFileUrl,
	fileIdFromSaveConfig: fileIdFromSaveConfig,
	goldFileKey: goldFileKey,
	loadFile: loadFile,
	saveFile: saveFile
};

